import { Injectable } from '@angular/core';
import { StateService } from '@uirouter/angular';

import { LoginModalService } from '../login/login-modal.service';
import { Principal } from './principal.service';
import { StateStorageService } from './state-storage.service';

import Auth0Lock from 'auth0-lock';
import { JhiLanguageHelper } from '../language/language.helper';
import { FeatureFlagsService } from './feature-flags.service';
import { IS_DEV, IS_DEV_USING_STAGING_BACKEND } from '../../app.constants';

const zenikaLogo = require('../../../content/images/znk.png');

let options = {
    allowSignUp: false,
    auth: {
        redirect: true,
        params: {
            scope: 'openid authorization email name given_name family_name picture locale groups',
        },
    },
    language: 'fr',
    languageDictionary: {
        title: 'Zenika - Platon',
    },
    theme: {
        logo: zenikaLogo,
        primaryColor: '#EE2238',
    },
    container: 'login-container',
};

@Injectable()
export class AuthService {
    lock;
    userProfile: Object;

    constructor(
        private principal: Principal,
        private $state: StateService,
        private stateStorageService: StateStorageService,
        private loginModalService: LoginModalService,
        private languageHelper: JhiLanguageHelper,
        private featureFlagService: FeatureFlagsService
    ) {}

    public login(languageKey?: string) {
        if (!languageKey) {
            languageKey = this.languageHelper.getCurrentLang();
        }
        options.language = languageKey;
        options.container = 'login-container-' + languageKey;

        if (!document.getElementById(options.container)) {
            return;
        }

        if (IS_DEV && !IS_DEV_USING_STAGING_BACKEND) {
            var a = document.createElement('a');
            a.href = 'http://localhost:3000';
            a.className = 'btn-dev-login ';
            a.innerText = 'DEV connect';
            document.getElementById(options.container).appendChild(a);
        } else {
            this.lock = new Auth0Lock(
                'jbKWpTV7ASlM1780gmvZ79uJPKAzCfVT', //TODO: inject value on build for different values in staging and prod
                'zenika.eu.auth0.com',
                options
            );
            // Call the show method to display the widget.
            this.lock.show();
        }
    }

    public logout() {
        // Remove token from localStorage
        localStorage.removeItem('authenticationToken');
        this.userProfile = undefined;
        // this.router.navigate(['']);
        location.reload();
    }

    authorize(force) {
        let authReturn = this.principal
            .identity(force)
            .then(authThen.bind(this));

        return authReturn;

        function authThen() {
            let isAuthenticated = this.principal.isAuthenticated();
            let toStateInfo =
                this.stateStorageService.getDestinationState().destination;

            if (isAuthenticated) {
                this.featureFlagService.fetchFlags().catch((err) => {
                    console.error(
                        'Failed fetch feature flags; all flagged features will be disabled',
                        err
                    );
                });
            }

            // an authenticated user can't access to login and register pages
            if (
                isAuthenticated &&
                toStateInfo.parent === 'account' &&
                (toStateInfo.name === 'login' ||
                    toStateInfo.name === 'register')
            ) {
                console.log('fetch');
                this.$state.go('home');
            }

            // recover and clear previousState after external login redirect (e.g. oauth2)
            let fromStateInfo =
                this.stateStorageService.getDestinationState().from;
            let previousState = this.stateStorageService.getPreviousState();
            if (previousState) {
                if (isAuthenticated && !fromStateInfo.name) {
                    this.stateStorageService.resetPreviousState();
                    this.$state.go(previousState.name, previousState.params);
                }
            } else if (!isAuthenticated && toStateInfo.name !== 'home') {
                // user is not authenticated. Show the state they wanted before you
                // send them to the login service, so you can return them when you're done
                let toStateParamsInfo =
                    this.stateStorageService.getDestinationState().params;
                this.stateStorageService.storePreviousState(
                    toStateInfo.name,
                    toStateParamsInfo
                );
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts